﻿import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAvalMatching extends GuiListGeneric {

    constructor() {
        super("GuiListAvalMatching");

    }

}
